import React from "react"
import Swiper from "swiper"

import Image from "./../image"

class NewStore extends React.Component {
  componentDidMount() {
    new Swiper(".new-store .swiper-container", {
      slidesPerView: 3,
      spaceBetween: 0,
      // Responsive breakpoints
      breakpoints: {
        // when window width is <= 768px
        768: {
          slidesPerView: 1.15,
          spaceBetween: 0,
        },
      },
    })
  }

  render() {
    return (
      <div className="new-store">
        <div className="container is-slim">
          <div data-aos="fade-up" className="has-text-centered">
            <h2 className="title is-2 mb-0">NEW STORE</h2>
            <small className="has-text-grey-light">新着の店舗</small>
          </div>
          <div data-aos="fade-up">
            <div className="swiper-container">
              <div className="swiper-wrapper">
                <div className="swiper-slide">
                  <a
                    className="card has-text-left"
                    href="https://picks.fun/shop/133"
                  >
                    <div className="bg-img-1" />
                    <div className="text">
                      チキンワークス白金 神宮外苑前店
                      <div className="small-text has-text-grey-light">
                        外苑前駅 徒歩6分
                      </div>
                    </div>
                  </a>
                </div>
                <div className="swiper-slide">
                  <a
                    className="card has-text-left"
                    href="https://picks.fun/shop/42"
                  >
                    <div className="bg-img-2" />
                    <div className="text">
                      バーガーマニア 恵比寿店
                      <div className="small-text has-text-grey-light">
                        恵比寿駅 徒歩3分
                      </div>
                    </div>
                  </a>
                </div>
                <div className="swiper-slide">
                  <a
                    className="card has-text-left"
                    href="https://picks.fun/shop/33"
                  >
                    <div className="bg-img-3" />
                    <div className="text">
                      アジアンビストロDai 駒沢店
                      <div className="small-text has-text-grey-light">
                        駒沢公園口から徒歩2分
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default NewStore
